export default __webpack_public_path__ + "static/media/navFrameBottom.ab62e430.png";